<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Contents</title>
<link href="css-template.css" rel="stylesheet" type="text/css"/>
<section aria-labelledby="Contents" epub:type="toc" role="doc-toc">
<h1 class="chaptitle-pre" epub:type="title" id="Contents"><span aria-label="Page ix" epub:type="pagebreak" id="page_ix" role="doc-pagebreak"><b>Contents</b></span></h1>
<p class="list-para2"><a href="#/07_Foreword">Foreword</a></p>
<p class="list-para3"><a href="#/07_Foreword"><i>A Tribute to Kathleen Steinhauer and Nellie Carlson</i></a></p>
<p class="list-para3">MARIA CAMPBELL</p>
<p class="topspace"></p>
<p class="list-para2"><a href="#/08_Acknowledgement">Acknowledgements</a></p>
<p class="topspace"></p>
<p class="list-para2"><a href="#/09_Introduction">Introduction</a></p>
<p class="list-para3"><a href="#/09_Introduction"><i>Two Strong Women Begin to Tell a Story</i></a></p>
<p class="list-para3">LINDA GOYETTE</p>
<p class="topspace1">
</p><p class="list-para1"><span href="#/10_Chapter01" title="Link target outside of Sample">1 <b>Daughters of Saddle Lake</b></span></p>
<p class="list-para1"><span href="#/11_Chapter02" title="Link target outside of Sample">2 <b>Surviving Residential School</b></span></p>
<p class="list-para1"><span href="#/12_Chapter03" title="Link target outside of Sample">3 <b>Love, Matrimony, and the <i>Indian Act</i></b></span></p>
<p class="list-para1"><span href="#/13_Chapter04" title="Link target outside of Sample">4 <b>Indian Rights for Indian Women</b></span></p>
<p class="list-para1"><span href="#/14_Chapter05" title="Link target outside of Sample">5 <b>A Tribute to Jenny Shirt Margetts</b></span></p>
<p class="list-para1"><span href="#/15_Chapter06" title="Link target outside of Sample">6 <b>How We Worked Together</b></span></p>
<p class="list-para1"><span href="#/16_Chapter07" title="Link target outside of Sample">7 <b>Fighting for Our Birthright</b></span></p>
<p class="list-para1"><span href="#/17_Chapter08" title="Link target outside of Sample">8 <b>This Is Our Land</b></span></p>
<p class="list-para2"><span href="#/18_ClosingWords" title="Link target outside of Sample"><b>Closing Words</b></span></p>
<p class="topspace">
</p><p class="list-para2a"><span aria-label="Page x" epub:type="pagebreak" id="page_x" role="doc-pagebreak"><span href="#/19_FamilyTree" title="Link target outside of Sample">Family Tree</span></span></p>
<p class="list-para2a"><span href="#/21_Timeline" title="Link target outside of Sample">Timeline</span></p>
<p class="list-para2a"><span href="#/22_HonourRoll" title="Link target outside of Sample">Honour Roll</span></p>
<p class="list-para2a"><span href="#/23_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="list-para2a"><span href="#/24_Glossary" title="Link target outside of Sample">Glossary</span></p>
<p class="list-para2a"><span href="#/25_FurtherReading" title="Link target outside of Sample">Further Reading</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?719c6cd2